import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Switch from 'react-switch';
import './AdminBrandSettings.scss';

import { updateBrandSettings } from '../../../../Actions/BrandActions';
import { getBrandSettings, getBrandName } from '../../../../Helpers/user_helpers';
import ShopMySelect from '../../../General/ShopMySelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import BrandedTooltip from '../../../General/Tooltip';

const AdminBrandSettings = props => {
  const { user } = props;

  // Allow them to send gifting only opportunities
  const canSendGiftingOnlyOpps = getBrandSettings(user).canSendGiftingOnlyOpps;
  const [isSendingGiftingOnlyOpps, setIsSendingGiftingOnlyOpps] = React.useState(false);
  const updateCanSendGiftingOnlyOpportunities = async () => {
    if (isSendingGiftingOnlyOpps) return window.ALERT.warn('Please wait for the previous request to complete.');
    setIsSendingGiftingOnlyOpps(true);
    await props.updateBrandSettings({ canSendGiftingOnlyOpps: !canSendGiftingOnlyOpps });
    window.ALERT.success(
      !canSendGiftingOnlyOpps
        ? `${getBrandName(user)} can now send gifting only opportunities.`
        : `${getBrandName(user)} can no longer send gifting only opportunities.`
    );
    setIsSendingGiftingOnlyOpps(false);
  };

  // Payment Terms (not required)
  const netPaymentTerms = getBrandSettings(user)?.netPaymentTerms;
  const [isUpdatingNetTerms, setIsUpdatingNetTerms] = React.useState(false);
  const updateNetPaymentTerms = async value => {
    if (isUpdatingNetTerms) return window.ALERT.warn('Please wait for the previous request to complete.');
    setIsUpdatingNetTerms(true);
    await props.updateBrandSettings({ netPaymentTerms: value ?? null });
    window.ALERT.success(value !== null ? `Payment Terms set to ${value || 'Instant'}.` : 'Payment Terms cleared.');
    setIsUpdatingNetTerms(false);
  };

  return (
    <div className='admin-brand-settings-container'>
      <div className='switch-container'>
        <Switch
          onChange={updateCanSendGiftingOnlyOpportunities}
          checked={canSendGiftingOnlyOpps}
          height={14}
          width={24}
          onColor='#11835a'
          offColor='#ccc'
          className='switch'
          checkedIcon={false}
          uncheckedIcon={false}
        />
        <div className='label'>Can Send Gifting Only Opportunities</div>
      </div>

      <div className='select-container'>
        <div className='label-container'>
          <div className='label'>Payment Terms</div>
          <BrandedTooltip message='Payment Terms help creators understand when they will be paid for an opportunity.'>
            <FontAwesomeIcon icon={faInfoCircle} />
          </BrandedTooltip>
        </div>
        <ShopMySelect
          className='select'
          disableSearch
          noStyling
          options={[
            { value: 0, label: 'Instant' },
            { value: 30, label: 'Net 30' },
            { value: 60, label: 'Net 60' },
            { value: 90, label: 'Net 90' },
            { value: null, label: 'No selection' }
          ]}
          value={netPaymentTerms ?? null}
          placeholder='No selection'
          onChangeValue={updateNetPaymentTerms}
          isDisabled={isUpdatingNetTerms}
        />
      </div>
    </div>
  );
};

AdminBrandSettings.propTypes = {
  user: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  updateBrandSettings
})(AdminBrandSettings);
